import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MOVEMENT_PETITION_ADD_NOTIFICATION = createFcmDetails('movement_petition_add_notification', {
	owner: 'Site Platform',
	context: 'comms stack',
	description: 'Flag to enable/disable the email notification for petitions being added to a movement.',
	import: false,
});
